export default function HeroVideo() {
  const videoWrapper = document.querySelectorAll<HTMLDivElement>(".js-video-wrapper");
  const videoBackgroundWrapper = document.querySelectorAll<HTMLDivElement>(".js-background-video-wrapper");

  if (videoWrapper && videoWrapper.length > 0) {
    videoWrapper.forEach((item) => {
      const video: HTMLVideoElement | null = item.querySelector(".js-video");
      const videoBtn: HTMLButtonElement | null = item.querySelector(".js-video-btn");

      if (video && videoBtn) {
        videoBtn.addEventListener("click", () => {
          video.play();
          video.style.opacity = "1";
          video.style.pointerEvents = "auto";
          videoBtn.setAttribute("aria-pressed", "true");
          videoBtn.style.opacity = "0";
          videoBtn.style.pointerEvents = "none";
        });
      }

      // if you click in the video wrapper then the video will play and the overlay will disappear
      item.addEventListener("click", () => {
        item.setAttribute("data-status", "playing");
      });
    });
  }

  if (videoBackgroundWrapper && videoBackgroundWrapper.length > 0) {
    videoBackgroundWrapper.forEach((item) => {
      const video: HTMLVideoElement | null = item.querySelector(".js-video");
      const videoBtn: HTMLButtonElement | null = item.querySelector(".js-video-btn");
      const videoBtnPlayAriaText = videoBtn?.getAttribute('data-site-settings-play')
      const videoBtnPauseAriaText = videoBtn?.getAttribute('data-site-settings-pause');

      if (video && videoBtn) {
        videoBtn.addEventListener("click", () => {
          if (video.paused) {
            video.play();
            videoBtn.textContent = videoBtnPauseAriaText ?? "Pause";
            videoBtn.setAttribute("aria-pressed", "true");
          } else {
            video.pause();
            videoBtn.textContent = videoBtnPlayAriaText ?? "Play";
            videoBtn.setAttribute("aria-pressed", "false");
          }
        });
      }
    });
  }
}
